angular.module('core')
  .service('exportService', ['customer', function($customer) {
    var buildExportUrl = function(urlTemplate, params, format) {
      var unusedParams = angular.copy(params);
      var url = urlTemplate.replace(/:(\w+)/g, function(match, key) {
        if (unusedParams.hasOwnProperty(key)) {
          delete unusedParams[key];
        }
        return params[key];
      });

      var standard = $customer.getAcademicStandard();
      if (standard) {
        unusedParams.ast = standard.academic_standard_name;
      }

      unusedParams.format = format ? format : 'csv';
      var parts = [];
      for (var key in unusedParams) {
        if (unusedParams[key]) {
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(unusedParams[key]));
        }
      }

      return url + ((url.indexOf('?') === -1) ? '?' : '&') + parts.join('&');
    };

    return {
      buildExportUrl: buildExportUrl
    };
  }]);